import React, { useState } from 'react';
import { X } from 'lucide-react';
import useModalEscape from '../../hooks/useModalEscape';
import useModalTransition from '../../hooks/useModalTransition';
import { privacySections, PRIVACY_LAST_UPDATED } from '../../data/legalPolicies';

const PrivacyPolicyModal = ({ isOpen, onClose }) => {
  const shouldRender = useModalTransition(isOpen);
  const [expandedSections, setExpandedSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setExpandedSections((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  useModalEscape(onClose, isOpen);

  if (!shouldRender) return null;

  return (
    <div
      className={`plp-modal-overlay privacy-modal-overlay modal-transition-${isOpen ? 'enter' : 'exit'}`}
      onClick={onClose}
    >
      <div
        className="privacy-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="privacy-modal-close" onClick={onClose} aria-label="Close Privacy Policy">
          <X size={20} />
        </button>

        <div className="privacy-header">
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
            <h2 className="privacy-title plp-modal-title" style={{ margin: 0 }}>
              Privacy Policy
            </h2>
          </div>
          <p className="privacy-subtitle">Last Updated: {PRIVACY_LAST_UPDATED}</p>
        </div>

        <div className="privacy-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {privacySections.map((sec) => (
            <div className="privacy-section" key={sec.id}>
              <div
                className="section-header"
                onClick={() => toggleSection(sec.id)}
              >
                <div className="section-number">
                  {sec.id.toString().padStart(2, '0')}
                </div>
                <h3>{sec.title}</h3>
                <div className="section-toggle">
                  {expandedSections[sec.id] ? '−' : '+'}
                </div>
              </div>
              {expandedSections[sec.id] && (
                <div className="section-content">
                  {sec.paragraphs?.map((p, idx) => (
                    <p key={idx}>{p}</p>
                  ))}
                  {sec.bullets && (
                    <ul>
                      {sec.bullets.map((b, idx) => (
                        <li key={idx}>{b}</li>
                      ))}
                    </ul>
                  )}
                  {sec.afterBullets?.map((p, idx) => (
                    <p key={idx}>{p}</p>
                  ))}
                </div>
              )}
            </div>
          ))}

          <div className="privacy-footer">
            <p>By using Avisa, you agree to this privacy policy</p>
            <p>© 2026 Avisa. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyModal;
